export default[
    {
        path: '/vale/alimentacao/trabalhador/cadastro/:trabalhador_id',
        name: 'cadastro do vale alimentação', 
        component: () => import(/* webpackChunkName: "Login" */ './page/cadastro.vue')
    },
    {
        path: '/vale/alimentacao/trabalhador/lista',
        name: 'lista do vale alimentação', 
        component: () => import(/* webpackChunkName: "Login" */ './page/lista.vue')
    },
    {
        path: '/vale/alimentacao/trabalhador/editar/:id/:trabalhador_id',
        name: 'editar vale alimentação', 
        component: () => import(/* webpackChunkName: "Login" */ './page/editar.vue')
    },
]